import React from "react";
import { TextField } from "@mui/material";
import { Box } from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";

interface SignupFormValues {
  fullName: string;
  businessName: string;
  email: string;
  password: string;
}

export type SignupFormSubmitHandler = SubmitHandler<SignupFormValues>;

interface SignupFormProps {
  onSubmit: SignupFormSubmitHandler,
  isLoading: boolean
}

const SignupForm = (props: SignupFormProps) => {
  const { register, handleSubmit } = useForm<SignupFormValues>();

  return (
    <Box component="form" onSubmit={handleSubmit(props.onSubmit)}>
      <TextField
        required
        fullWidth
        margin="normal"
        label="Full name"
        type="text"
        variant="outlined"
        {...register("fullName")}
      />
      <TextField
        fullWidth
        margin="normal"
        label="Business name"
        type="text"
        variant="outlined"
        {...register("businessName")}
      />
      <TextField
        required
        fullWidth
        margin="normal"
        label="Work Email"
        type="email"
        variant="outlined"
        {...register("email")}
      />
      <TextField
        required
        fullWidth
        margin="normal"
        label="Password"
        type="password"
        variant="outlined"
        {...register("password")}
      />
      <LoadingButton
        disableElevation
        loading={props.isLoading}
        variant="contained"
        type="submit"
        fullWidth
        sx={{ mt: 2, mb: 2, height: "56px" }}
      >
        <span>Sign up</span>
      </LoadingButton>
    </Box>
  );
};

export default SignupForm;
